export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgU3RhcnRpbmdQcm9jZXNzRGlhbG9nVHlwZSA9IG51bGwgfCB7CiAgY2FsbGJhY2s6ICgpID0+IFByb21pc2U8dm9pZD4KfTsK"